import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './AccountScreen.css';

function getUser() {
  try {
    const raw = sessionStorage.getItem('focusup_user');
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

function getStats() {
  try {
    const raw = localStorage.getItem('focusup_stats');
    if (raw) return JSON.parse(raw);
  } catch {}
  return { totalSessions: 0, totalMinutes: 0, currentStreak: 0, bestStreak: 0 };
}

export function AccountScreen() {
  const navigate = useNavigate();
  const [user, setUser] = useState(getUser);
  const stats = getStats();
  const level = Math.floor(stats.totalSessions / 5) + 1;
  const xp = stats.totalSessions * 50;

  const signOut = useCallback(() => {
    sessionStorage.removeItem('focusup_user');
    sessionStorage.removeItem('focusup_jwt');
    setUser(null);
    navigate('/');
  }, [navigate]);

  const resetStats = useCallback(() => {
    if (confirm('Remettre toutes les statistiques a zero ?')) {
      localStorage.removeItem('focusup_stats');
      navigate('/');
    }
  }, [navigate]);

  return (
    <div className="fu-account">
      <div className="fu-account-header">
        <button className="fu-back-btn" onClick={() => navigate('/')}>← Retour</button>
        <h1>Mon compte</h1>
      </div>

      {/* Profile */}
      {user ? (
        <div className="fu-profile-card">
          <div className="fu-profile-avatar">{user.name.charAt(0).toUpperCase()}</div>
          <div className="fu-profile-info">
            <strong>{user.name}</strong>
            <span>{user.email}</span>
          </div>
        </div>
      ) : (
        <div className="fu-profile-card">
          <div className="fu-profile-avatar">?</div>
          <div className="fu-profile-info">
            <strong>Non connecte</strong>
            <span>Connecte-toi pour sauvegarder ta progression</span>
          </div>
        </div>
      )}

      {/* Level card */}
      <div className="fu-account-card">
        <div className="fu-account-card-header">
          <span className="fu-account-level">Niveau {level}</span>
          <span className="fu-account-xp">{xp} XP</span>
        </div>
        <div className="fu-account-progress">
          <div className="fu-account-progress-fill" style={{ width: `${(stats.totalSessions % 5) * 20}%` }} />
        </div>
      </div>

      {/* Stats recap */}
      <div className="fu-account-section">
        <h2>Recap</h2>
        <div className="fu-account-rows">
          <div className="fu-account-row">
            <span>🎯 Sessions totales</span>
            <strong>{stats.totalSessions}</strong>
          </div>
          <div className="fu-account-row">
            <span>⏱ Temps total</span>
            <strong>{Math.floor(stats.totalMinutes / 60)}h{String(stats.totalMinutes % 60).padStart(2, '0')}</strong>
          </div>
          <div className="fu-account-row">
            <span>🔥 Streak actuel</span>
            <strong>{stats.currentStreak}</strong>
          </div>
          <div className="fu-account-row">
            <span>🏆 Meilleur streak</span>
            <strong>{stats.bestStreak}</strong>
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="fu-account-section">
        <h2>Parametres</h2>
        <div className="fu-account-rows">
          <button className="fu-account-row fu-account-action" onClick={resetStats}>
            <span>🗑 Reinitialiser mes stats</span>
            <span className="fu-chevron">›</span>
          </button>
          {user && (
            <button className="fu-account-row fu-account-action fu-account-danger" onClick={signOut}>
              <span>🚪 Deconnexion</span>
              <span className="fu-chevron">›</span>
            </button>
          )}
        </div>
      </div>

      <p className="fu-account-footer">FocusUp v1.0 — Alterrego</p>
    </div>
  );
}
